/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../components/shared/Loader';

const loading = () => <Loader message={'Loading. Please wait...'} />;

// All layouts/containers
const AuthLayout = Loadable({
  loader: () => import('./Auth'),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading,
});

const VerticalSystemLayout = Loadable({
  loader: () => import('./systemLayout/Vertical'),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading,
});

const VerticalSystemSignUpLayout = Loadable({
  loader: () => import('./systemSignUpLayout'),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading,
});

const VerticalLayout = Loadable({
  loader: () => import('./adminLayout/Vertical'),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading,
});

export { AuthLayout, VerticalLayout, VerticalSystemLayout, VerticalSystemSignUpLayout };
